module.exports = __webpack_public_path__ + "img/svelte.0f13c44e.svg";